import { render, staticRenderFns } from "./ticketAssociativeClassification.vue?vue&type=template&id=654893a7&scoped=true"
import script from "./ticketAssociativeClassification.vue?vue&type=script&lang=js"
export * from "./ticketAssociativeClassification.vue?vue&type=script&lang=js"
import style0 from "./ticketAssociativeClassification.vue?vue&type=style&index=0&id=654893a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654893a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654893a7')) {
      api.createRecord('654893a7', component.options)
    } else {
      api.reload('654893a7', component.options)
    }
    module.hot.accept("./ticketAssociativeClassification.vue?vue&type=template&id=654893a7&scoped=true", function () {
      api.rerender('654893a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopOperationCenter/dialog/ticketAssociativeClassification.vue"
export default component.exports